export interface AdminAccessProfile {role?:string|null;adminRole?:string|null;status?:string;permissions?:string[]}
const entries=[
 {to:'/admin/applications',icon:'fa-user-check',label:'申請審核'},
 {to:'/admin/affiliates',icon:'fa-building',label:'兼職管理',permission:'affiliates:read'},
 {to:'/admin/orders',icon:'fa-clipboard-list',label:'訂單管理',permission:'orders:read'},
 {to:'/admin/contacts',icon:'fa-address-book',label:'客戶管理',permission:'orders:read'},
 {to:'/admin/products',icon:'fa-plane',label:'產品管理',permission:'products:read'},
 {to:'/admin/payouts',icon:'fa-money-bill-wave',label:'撥款管理',permission:'settlements:read'},
 {to:'/admin/funnel',icon:'fa-filter',label:'漏斗分析',permission:'audit:read'},
 {to:'/admin/users',icon:'fa-user-cog',label:'用戶管理'},
 {to:'/admin/tenants',icon:'fa-window-maximize',label:'靜態頁管理',permission:'websites:access'},
]
export const isFullAdminProfile=(p:AdminAccessProfile|null|undefined)=>p?.role==='admin'&&p.status==='active'&&['super_admin','admin'].includes(p.adminRole||'')
export const canManageStaticPages=(p:AdminAccessProfile|null|undefined)=>p?.role==='admin'&&p.status==='active'&&(isFullAdminProfile(p)||p.adminRole==='op'||Boolean(p.permissions?.includes('websites:access')))
export function adminNavigation(p:AdminAccessProfile|null|undefined){
 if(p?.role!=='admin'||p.status!=='active')return []
 if(isFullAdminProfile(p))return entries
 const paths:Record<string,string[]>={sales:['/admin/contacts','/admin/orders'],accounting:['/admin/payouts'],op:['/admin/products','/admin/orders','/admin/tenants']}
 const allowed=paths[p.adminRole||'']
 if(allowed)return [...new Set([...allowed,...(canManageStaticPages(p)?['/admin/tenants']:[])])].map(path=>entries.find(item=>item.to===path)!)
 if(p.adminRole==='staff')return entries.filter(item=>item.permission&&p.permissions?.includes(item.permission))
 return []
}
export function canAccessAdminPath(p:AdminAccessProfile|null|undefined,path:string):boolean{
 if(path==='/register/affiliate')return isFullAdminProfile(p)
 if(path==='/admin/settings')return isFullAdminProfile(p)||(p?.role==='admin'&&p.status==='active'&&p.adminRole==='staff'&&Boolean(p.permissions?.some(permission=>['config:read','config:write'].includes(permission))))
 return adminNavigation(p).some(item=>path===item.to||path.startsWith(item.to+'/'))
}
export function adminHomePath(p:AdminAccessProfile|null|undefined):string{
 if(isFullAdminProfile(p))return '/admin/affiliates'
 return adminNavigation(p)[0]?.to||(canAccessAdminPath(p,'/admin/settings')?'/admin/settings':'/login?access=unavailable')
}
